import React from 'react';

import { Nullable } from '@clearverify/types';

import { ActiveInactive, useStatesListQuery } from 'src/api';
import { useCurrentUser } from 'src/hooks/user';

type UseStatesListArgs = {
  state?: Nullable<string>;
};

export const useCurrentUserStatesList = ({ state }: UseStatesListArgs = {}) => {
  const { user } = useCurrentUser();

  const filterState = state ?? user?.address?.state;

  const { data, loading } = useStatesListQuery({
    variables: {
      filter: {
        name: {
          equals: filterState,
        },
      },
    },
    skip: !filterState,
  });

  const statesList = React.useMemo(
    () => (data?.stateList ?? []).toSorted((a, b) => a.name?.localeCompare(b.name || '') || 0),
    [data?.stateList],
  );

  const isRequestAutoApproveStatusInactive = React.useMemo(
    () =>
      !statesList?.length ||
      !statesList[0]?.privacySetting ||
      statesList[0]?.privacySetting === ActiveInactive.Inactive,
    [statesList],
  );

  return { isRequestAutoApproveStatusInactive, statesList, loading };
};
